import React, { createContext, useContext, useMemo, useState } from 'react'

const RangeDateContext = createContext(null)

const useRangeDate = () => {
  const context = useContext(RangeDateContext)
  if (!context) {
    throw new Error('useRangeDate must be used within a MenuProvider')
  }
  return context
}

const RangeDateProvider = props => {
  const [rangeDate, setRangeDate] = useState([])

  const value = useMemo(() => ({ rangeDate, setRangeDate }), [rangeDate])
  return <RangeDateContext.Provider value={value} {...props} />
}

export { RangeDateProvider, useRangeDate }
